<template>
    <ApplicationTableCustomField
        fieldType="locality"
        :items="dataObj.item.form.real_estate_target"
    />
</template>

<script>
import ApplicationTableCustomField from '@/modules/applications/components/ApplicationTableCustomField';
export default {
    name: 'LocalityCustomField',
    components: { ApplicationTableCustomField },
    props: {
        dataObj: {
            type: Object,
        }
    },
};
</script>
